import React, { useState } from "react";
import "./Billing.css";
import { Container } from "react-bootstrap";
import Payment from '../../images/dollar.png'
import Footer from '../Footer/Footer'
import Navbaruser from "../Navbar/Navbaruser";
import Sidebaruser from "../Sidebar/SIdebaruser";

const Billing = () => {
  const [isActive, setActive] = useState(false);

  const toggleClass = () => {
      setActive(!isActive);
  }
  return (
    <>
      <div className="App">
        <div className="side-bar ">
          <Sidebaruser handleToggle={toggleClass} isActive={isActive}/>
        </div>
        <div className="main w-100">
          <Navbaruser isActive={isActive}/>
          <Container>
            <div className="billing-head">
             
              <div className="billing-main">
             <div className="billing-plan d-flex align-items-center col-lg-12">
                 <div className="plan col-12 col-lg-8 col-md-12 col-sm-12">
                     <div className="plan-title">My Plan</div>
                     <div className="plan-box">
                         <div className="plan-location">
                             <div className="plan-location-title">
                             Regular <span>6 Locations</span>
                             </div>
                             <div className="plan-location-description">
                             Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed <br /> do eiusmod tempor incididunt ut labore 
                             </div>
                         </div>
                         <div className="plan-img">
                             <img src={Payment} alt="" />
                         </div>
                     </div>
                 </div>
                 <div className="plan col-12 col-lg-4 col-md-12 col-sm-12">
                 <div className="plan-title">Billind Information</div>
                 <div className="plan-box billind-box">
                     <ul className="billind-list">
                         <li className="billind-list-items">
                             <div className="billind-title">
                                 Last Digits:
                             </div>
                             <div className="billind-details">
                                 3969
                             </div>
                         </li>
                         <li className="billind-list-items">
                             <div className="billind-title">
                                 Expiration:
                             </div>
                             <div className="billind-details">
                                 12/20122
                             </div>
                         </li>
                         <li className="billind-list-items">
                             <div className="billind-title">
                                 Expiration:
                             </div>
                             <div className="billind-details">
                                 12/20122
                             </div>
                         </li>
                         <li className="billind-list-items">
                             <div className="billind-title">
                                 Type:
                             </div>
                             <div className="billind-details">
                                 Mastercard
                             </div>
                         </li>
                     </ul>
                 </div>
                 </div>
             </div>
             <div className="invoice col-lg-12">
                 <div className="plan-title in-title">
                     Invoice
                </div>           
             <ul className="invoice-list">
                 <li className="invoice-list-iten">
                     <div className="invoice-month">
                         July 15
                     </div>
                     <div className="invoice-price">
                         199$
                     </div>
                 </li>
                 <li className="invoice-list-iten">
                     <div className="invoice-month">
                         July 15
                     </div>
                     <div className="invoice-price">
                         199$
                     </div>
                 </li>
                 <li className="invoice-list-iten">
                     <div className="invoice-month">
                         July 15
                     </div>
                     <div className="invoice-price">
                         199$
                     </div>
                 </li>
                 <li className="invoice-list-iten">
                     <div className="invoice-month">
                         July 15
                     </div>
                     <div className="invoice-price">
                         199$
                     </div>
                 </li>
                 <li className="invoice-list-iten">
                     <div className="invoice-month">
                         July 15
                     </div>
                     <div className="invoice-price">
                         199$
                     </div>
                 </li>
                 <li className="invoice-list-iten">
                     <div className="invoice-month">
                         July 15
                     </div>
                     <div className="invoice-price">
                         199$
                     </div>
                 </li>
             </ul>
            </div>
              </div>
            </div>

          </Container>
          <Footer />
        </div>
        
      </div>
      
    </>
  );
};

export default Billing;
